import React from "react"
import ImageHeader from "../../components/ImageHeader"
import headerImage from "../../assets/img/banners/Explore_Plan_Cover.jpg"
import { EducatorHomepage } from "../../components/OnboardingHomepage"
import { EmeraldHost } from "../../config"
import { getCurrentRole } from "../../util"
import StudentHomepage from "../../components/StudentHomepage/index.js"
import _ from "lodash"

const HomePage = ({ currentUser, handleHideIntercom }) => {
  const redirectToEmeraldHome = () => {
    window.location.href = EmeraldHost() + "home"
  }

  const userRole = getCurrentRole(currentUser)

  return (
    <ImageHeader
      image={headerImage}
      titleContents={
        currentUser &&
        `Welcome, ${currentUser["first-name"]}${
          currentUser["last-name"] !== null ? ` ${currentUser["last-name"]}` : ""
        }!`
      }
      containerClass='modules-container'
    >
      <div className='col-lg-12'>
        {userRole === "EDUCATOR" ? (
          <EducatorHomepage />
        ) : _.includes(["STUDENT", "CHILD"], userRole) ? (
          <StudentHomepage currentUser={currentUser} handleHideIntercom={handleHideIntercom} />
        ) : _.includes(["HOMESCHOOLER", "PARENT"], userRole) ? (
          redirectToEmeraldHome()
        ) : (
          <div style={{ textAlign: "center" }}>
            <h1>The Learning Dashboard is in the process of a huge update!</h1>
            <h2>
              A Teacher Onboarding Guide is now available. Please do a “hard refresh” (shift+refresh
              button) to make sure you&apos;re on the latest version of our dashboard!
            </h2>
          </div>
        )}
      </div>
    </ImageHeader>
  )
}

export default HomePage
